import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { ChipotleuReVerificationSuccessModalContentFragment } from '@/models/cms';

@Component({
    name: 'CmgChipotleUReverificationSuccessModal'
})

export default class CmgChipotleUReverificationSuccessModal extends Vue {
    chipotleuReVerificationSuccessModal: ChipotleuReVerificationSuccessModalContentFragment = {};

    get visible(): boolean {
        return this.$appStore.state.ui.modals.chipotleUReverificationSuccessModal.visible;
    }

    get isMobile(): boolean {
        return this.$services.ui.isMobile();
    }

    get title(): string {
        return this.chipotleuReVerificationSuccessModal.headline || 'congratulations! you\'re verified';
    }

    get description(): string {
        return this.graduationDate 
            ? this.chipotleuReVerificationSuccessModal.body || '<p>You\'re all set! You\'ve been re-verified for ChipotleU. Your expected graduation date is</p>' 
            : '<p>You\'re all set! You\'ve been re-verified for ChipotleU. </p>';
    }

    get ctaText(): string {
        return this.chipotleuReVerificationSuccessModal.ctaText || 'continue';
    }

    get customerProfile() {
        return this.$appStore.state.customer.profile;
    }

    get graduationDate(): string | undefined {
        if (!this.customerProfile?.student?.graduationDate) {
            return undefined;
        }
        
        const date = new Date(this.customerProfile.student.graduationDate);
        return date.toLocaleDateString('en-US', { year: 'numeric', month: '2-digit', day: '2-digit' });
    }

    get chipUMedallionImageUrl(): string {
        return this.chipotleuReVerificationSuccessModal.image || this.$appStore.state.cms.images.loyalty.chipUMedallion.default;
    }

    get lottieBackgroundSparklesUrl(): string {
        return this.$appStore.state.cms.animations.bag.lottieBackgroundSparklesUrl;
    }

    async mounted() {
        this.$services.ui.firstFocus();
        await this.$services.config.setChipotleuReVerificationSuccessModal();
        this.chipotleuReVerificationSuccessModal = this.$services.config.getChipotleuReVerificationSuccessModal() || {};
    }

    onClose() {
        this.$services.ui.setModalVisibility('chipotleUReverificationSuccessModal', false);
    }
}
